/**
 * A function for determining if the image should fill the parent container or not.
 */
export var shouldFillParentContainer = function shouldFillParentContainer(props) {
  return !props.width && !props.height;
};